type Env = 'dev' | 'prod';

const getEnv = () => process.env.REACT_APP_ENV as Env;

const isDev = () => process.env.REACT_APP_ENV === 'dev';

const isProd = () => process.env.REACT_APP_ENV === 'prod';

export { getEnv, isDev, isProd };
